import type { Phrases } from '../../common/Phrases.d';
import type { ButtonGroupOption } from '../../../../components/react-hook-form/ButtonGroup';

import React, { useMemo } from 'react';
// import { ButtonGroup } from '../../../../components/react-hook-form/ButtonGroup';
import { ButtonCheckboxGroup } from '/react4xp/components/react-hook-form/buttonCheckboxGroup/ButtonCheckboxGroup';

import {
	SERVICES_FIELD_NAME,
	SERVICES_FREETEXT_FIELD_NAME,
	FIELD_VALUE_REACTIONS,
} from '../constants';


export const ReactionsButtonGroup = ({
	phrases,
	...otherProps
}: {
	phrases: Phrases;
}): React.JSX.Element => {

	const OPTIONS: ButtonGroupOption[] = useMemo(() => [{
		label: phrases['notificationForm.services.reactionsField.value.overdose'],
		value: FIELD_VALUE_REACTIONS.OVERDOSE,
	},{
		label: phrases['notificationForm.services.reactionsField.value.respiratoryArrest'],
		value: FIELD_VALUE_REACTIONS.RESPIRATORY_ARREST,
	},{
		label: phrases['notificationForm.services.reactionsField.value.cardiacArrest'],
		value: FIELD_VALUE_REACTIONS.CARDIAC_ARREST,
	},{
		label: phrases['notificationForm.services.reactionsField.value.unconsciousOrNotContactable'],
		value: FIELD_VALUE_REACTIONS.UNCONSCIOUS_OR_NOT_CONTACTABLE,
	},{
		label: phrases['notificationForm.services.reactionsField.value.convulsiveSeizures'],
		value: FIELD_VALUE_REACTIONS.CONVULSIVE_SEIZURES,
	},{
		label: phrases['notificationForm.services.reactionsField.value.other'],
		value: FIELD_VALUE_REACTIONS.OTHER,
	}], [phrases]);

	return (
		<ButtonCheckboxGroup
			{...otherProps}
			afterClick={({newValue, setValue}) => {
				if (!newValue || (Array.isArray(newValue) && !newValue.includes(FIELD_VALUE_REACTIONS.OTHER))) {
					// Yes, empty string can be set on optional text fields.
					setValue(SERVICES_FREETEXT_FIELD_NAME.REACTIONS_OTHER, '', { shouldValidate: true });
				}
			}}
			className='z-0'
			description={phrases['notificationForm.term.chooseOneOrMore']}
			// multiple
			name={SERVICES_FIELD_NAME.REACTIONS}
			options={OPTIONS}
		/>
	);
};
